// Roles allowed to manage account-wide tooling such as healthchecks. The
// check is deliberately positive (not "everyone but member/analyst") because
// the rule is "OWNER or ADMIN of the main organisation", nothing else.
export const MAIN_ORG_MANAGER_ROLES = ["OWNER", "ADMIN"]

// True when the user is an OWNER or ADMIN of the root (main) organisation.
// `user` is the /user payload (organisation_role), `fullOrganisation` the
// /orgs payload (is_root_org). Both missing → false: the gate stays closed
// until the data is loaded rather than flashing open.
export const isMainOrgManager = (user: any, fullOrganisation: any): boolean => {
    if (!user || !fullOrganisation) return false
    if (!fullOrganisation.is_root_org) return false
    const role = String(user.organisation_role ?? "").toUpperCase()
    return MAIN_ORG_MANAGER_ROLES.includes(role)
}
